import * as yup from 'yup';
import { getValidationSchema as getDetailsValidationSchema } from '../../../CaregiverDetailsStep/validators';
import { getValidationSchema as getContactValidationSchema } from '../../../CaregiverContactDetailsStep/validators';

export const getValidationSchema = () =>
  yup.object().shape({
    caregiverDetails: getDetailsValidationSchema(),
    caregiverContactDetails: getContactValidationSchema(),
  });
